import Vue from "vue";
import { URLS } from "@/api/urls.js";
// import store from "@/store/index.js";

const Apis = {
  // =====================================================================================
  // === API Test ===
  // =====================================================================================
  async getIpClient(callBackFunction) {
    const { data } = await Vue.axios.get(
      "https://ipinfo.io/json?token=7bf79be6d4dfb5",
    );
    return callBackFunction(data);
  },

  async goodLuck(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.test.goodLuck,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },

  // =====================================================================================
  // === mtrace Vertify ===
  // =====================================================================================
  async mtraceVerifyNo(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      "https://api.mtrace.go.kr/rest/verifyNo/userHistInfoUseAgree/verifyNoReq",
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async userHistInfoSvcUseAgreeReq(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      "https://api.mtrace.go.kr/rest/verifyNo/userHistInfoUseAgree/userHistInfoSvcUseAgreeReq",
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async deleteUserHistInfoSvcUseAgree(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      "https://api.mtrace.go.kr/rest/verifyNo/userHistInfoUseAgree/deleteUserHistInfoSvcUseAgree",
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  // =====================================================================================
  // === space Info ===
  // =====================================================================================
  async insertDealCompany(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.setup.insertDealCompany,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async updateDealCompany(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.setup.updateDealCompany,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async infoDealCompany(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.setup.infoDealCompany,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async comboDealCompanies(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.setup.comboDealCompanies,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listDealCompanies(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.setup.listDealCompanies,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  // =====================================================================================
  // === user controller ===
  // =====================================================================================
  async login(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.user.login,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async logout(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.user.logout,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async pageCount(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.user.pageCount,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async findID(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.user.findID,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async tempPassword(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.user.tempPassword,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async changePassword(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.user.changePassword,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async accountCheck(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.user.accountCheck,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async insertUser(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.user.insertUser,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async joinUser(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.user.joinUser,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async searchCompanies(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.user.searchCompanies,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async updateUser(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.user.updateUser,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async updateUserFree(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.user.updateUserFree,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async infoUser(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.user.infoUser,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async getUserType(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.user.getUserType,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listUsers(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.user.listUsers,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async insertUsersControl(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.user.insertUsersControl,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async deleteUsersControl(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.user.deleteUsersControl,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async treeManagermentCompanies(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.user.treeManagermentCompanies,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listAccesableServices(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.user.listAccesableServices,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  // =====================================================================================
  // === farm controller ===
  // =====================================================================================
  async comboCompanies(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.farm.comboCompanies,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async comboFarms(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.farm.comboFarms,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async comboBuildings(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.farm.comboBuildings,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async comboRooms(parmas, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.farm.comboRooms,
      JSON.stringify(parmas),
    );
    return callBackFunction(data);
  },
  async infoFarm(parmas, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.farm.infoFarm,
      JSON.stringify(parmas),
    );
    return callBackFunction(data);
  },
  async insertFarm(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.farm.insertFarm,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async updateFarm(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.farm.updateFarm,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async updateFarmFree(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.farm.updateFarmFree,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async infoBuilding(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.farm.infoBuilding,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async updateBuildingFree(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.farm.updateBuildingFree,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async insertBuildingOne(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.farm.insertBuildingOne,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async infoRoom(parmas, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.farm.infoRoom,
      JSON.stringify(parmas),
    );
    return callBackFunction(data);
  },
  async updateRoom(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.farm.updateRoom,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async insertRoom(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.farm.insertRoom,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async infoCompany(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.farm.infoCompany,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async updateCompany(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.farm.updateCompany,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async updateCompanyFree(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.farm.updateCompanyFree,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async insertCompany(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.farm.insertCompany,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  // =====================================================================================
  // === device controller ===
  // =====================================================================================
  async comboSensors(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.device.comboSensors,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async comboSensorData(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.device.comboSensorData,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async getNowControllerValue(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.device.getNowControllerValue,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async comboData_names(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.device.comboData_names,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  // =====================================================================================
  // === 자동제어  ===
  // =====================================================================================
  async listMonitoringControllers(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.listMonitoringControllers,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async infoDetailRoomControllers(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.infoDetailRoomControllers,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listSettingHistories(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.listSettingHistories,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async infoSettingHistory(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.infoSettingHistory,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async saveControllerSetting(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.saveControllerSetting,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async stopRemoteControl(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.stopRemoteControl,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async saveSeasonRange(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.saveSeasonRange,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async deleteSeasonRange(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.deleteSeasonRange,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async comboSeasonRanges(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.comboSeasonRanges,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listSeasonRanges(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.listSeasonRanges,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async infoSeasonRange(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.infoSeasonRange,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async saveWeightRange(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.saveWeightRange,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async deleteWeightRange(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.deleteWeightRange,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async comboWeightRanges(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.comboWeightRanges,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listWeightRanges(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.listWeightRanges,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async infoWeightRange(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.infoWeightRange,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async saveControlRangeSettings(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.saveControlRangeSettings,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async deleteControlRangeSettings(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.deleteControlRangeSettings,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listControlRangeSettings(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.listControlRangeSettings,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async saveFanControlPreset(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.saveFanControlPreset,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async loadFanControlPreset(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.loadFanControlPreset,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async comboFanControlPresets(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.comboFanControlPresets,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async confirmFanControlPreset(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.confirmFanControlPreset,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },

  async comboDeodorizers(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.comboDeodorizers,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async infoDeodorizerSetting(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.infoDeodorizerSetting,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listMonitorDeodorizers(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.listMonitorDeodorizers,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async saveDeodorizerSetting(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.saveDeodorizerSetting,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },

  async setStatusOfDeodorizer(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.setStatusOfDeodorizer,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },

  async deodorizerOnLines(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.deodorizerOnLines,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },

  async deodorizerOnAllLines(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.deodorizerOnAllLines,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },

  async deodorizerOffAllLines(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.deodorizerOffAllLines,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },

  async deodorizerAutoAllLines(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.deodorizerAutoAllLines,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },

  async deodorizerOffLines(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.deodorizerOffLines,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },

  async deodorizerAutoLines(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.deodorizerAutoLines,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },

  async deodorizerManualLines(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.control.deodorizerManualLines,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async treeDeodorizerDviceMonitoring(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.device.treeDeodorizerDviceMonitoring,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async updateDeodorizer(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.device.updateDeodorizer,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },

  // =====================================================================================
  // === monitor controller ===
  // =====================================================================================
  async buildingSummaryView(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.monitor.buildingSummaryView,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async farmSummaryViewForLite(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.monitor.farmSummaryViewForLite,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async farmSummaryView(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.monitor.farmSummaryView,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async roomDailyView(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.monitor.roomDailyView,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async roomDailyViewServices(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.monitor.roomDailyViewServices,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async room24hoursView(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.monitor.room24hoursView,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async roomRawDataView(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.monitor.roomRawDataView,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async monitoringSummary(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.monitor.monitoringSummary,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async monitoringWeather(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.monitor.monitoringWeather,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async weatherForDeodorizer(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.monitor.weatherForDeodorizer,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async summaryPigInfo(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.monitor.summaryPigInfo,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listFarmKepcoData(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.monitor.listFarmKepcoData,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async kepcoDataDailyView(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.monitor.kepcoDataDailyView,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listTimelyKepcoData(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.monitor.listTimelyKepcoData,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async kepcoDataMonthlyView(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.monitor.kepcoDataMonthlyView,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listTimelyKepcoDataEach(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.monitor.listTimelyKepcoDataEach,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async kepcoDataDailyViewEach(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.monitor.kepcoDataDailyViewEach,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async kepcoDataMonthlyViewEach(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.monitor.kepcoDataMonthlyViewEach,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async weatherForecast(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.monitor.weatherForecast,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async weatherDataDailyView(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.monitor.weatherDataDailyView,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  // =====================================================================================
  // === record ===
  // =====================================================================================
  async listCountHeadOfFarmPerMonth(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.esg.listCountHeadOfFarmPerMonth,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listSlaughterHeadOfFarmPerDay(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.esg.listSlaughterHeadOfFarmPerDay,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listSlaughterHeadOfFarmPerMonth(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.esg.listSlaughterHeadOfFarmPerMonth,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async infoMarketRealTime(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.esg.infoMarketRealTime,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listAmountHistoryPerDay(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.esg.listAmountHistoryPerDay,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listCattleGradeData(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.esg.listCattleGradeData,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async getCattleTrace(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.esg.getCattleTrace,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  // =====================================================================================
  // === Esg ===
  // =====================================================================================
  async comboEsgFarms(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.esg.comboEsgFarms,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async comboKepcoFarms(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.esg.comboKepcoFarms,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async estimateAmountForEnergyPerMonth(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.esg.estimateAmountForEnergyPerMonth,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listAmountForEnergyPerMonth(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.esg.listAmountForEnergyPerMonth,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async monitoringEsgValueOfFarm(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.esg.monitoringEsgValueOfFarm,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async monitoringEsgValueOfFarm2(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.esg.monitoringEsgValueOfFarm2,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async accumulateWattPerDay(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.esg.accumulateWattPerDay,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async accumulateWattLastYearMonth(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.esg.accumulateWattLastYearMonth,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },

  async certifyLowCarbonBase(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.esg.certifyLowCarbonBase,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  // =====================================================================================
  // === alert controller ===
  // =====================================================================================
  async listAlertSetupOfFarm(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.alert.listAlertSetupOfFarm,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async saveAlertSetupOfRoom(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.alert.saveAlertSetupOfRoom,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async savePersonalChoicedAlerts(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.alert.savePersonalChoicedAlerts,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async infoPersonalChoicedAlerts(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.alert.infoPersonalChoicedAlerts,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listAlertSetupOfFarm2025(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.alert.listAlertSetupOfFarm2025,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async saveAlertSetup2025(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.alert.saveAlertSetup2025,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async saveAlertVoiceSetup(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.alert.saveAlertVoiceSetup,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  // =====================================================================================
  // === package biz ===
  // =====================================================================================
  async comboMilkingFarms(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.package.comboMilkingFarms,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listDairyMilk(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.package.listDairyMilk,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async statisticsOfDairyMilkPerEntity(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.package.statisticsOfDairyMilkPerEntity,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async statisticsOfDairySuckMilkPerEntity(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.package.statisticsOfDairySuckMilkPerEntity,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listDairySuckMilk(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.package.listDairySuckMilk,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async statisticsOfDairyMilkMonthly(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.package.statisticsOfDairyMilkMonthly,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async statisticsOfDairyMilkDaily(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.package.statisticsOfDairyMilkDaily,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listRawDataOfPackage(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.package.listRawDataOfPackage,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async statisticsOfDiaryWaterTimely(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.package.statisticsOfDiaryWaterTimely,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async statisticsOfDairyWaterDaily(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.package.statisticsOfDairyWaterDaily,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listBI01dataOfPackage(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.package.listBI01dataOfPackage,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listDiaryBI01dataOfEntity(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.package.listDiaryBI01dataOfEntity,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async monitorEC08dataOfPackageInFarm(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.package.monitorEC08dataOfPackageInFarm,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async monitorEC01dataOfPackageInFarm(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.package.monitorEC01dataOfPackageInFarm,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async monitorEC05dataOfPackageInFarm(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.package.monitorEC05dataOfPackageInFarm,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listAF08dataOfPackage(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.package.listAF08dataOfPackage,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listAF01dataOfPackage(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.package.listAF01dataOfPackage,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listAF01DailyOfDevice(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.package.listAF01DailyOfDevice,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  // =====================================================================================
  // === AS ===
  // =====================================================================================
  async insertAsHead(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.cs.insertAsHead,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async updateAsHead(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.cs.updateAsHead,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listAsHeads(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.cs.listAsHeads,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async infoAsProcess(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.cs.infoAsProcess,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async insertNotice(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.cs.insertNotice,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async updateNotice(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.cs.updateNotice,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listNotices(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.cs.listNotices,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async listAlertsOfFarm(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.alert.listAlertsOfFarm,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  // =====================================================================================
  // === Ai ===
  // =====================================================================================
  async getDivisionsOfRoomsInFarm(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.ai.getDivisionsOfRoomsInFarm,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  async predictWatt(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.ai.predictWatt,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  // async predictWatt(params, callBackFunction) {
  //   const { data } = await Vue.axios.post(
  //     URLS.ai.predictWatt,
  //     params,
  //     { headers: { "Content-Type": "application/json" } }
  //   );
  //   return callBackFunction(data);
  // },
  // =====================================================================================
  // === system ===
  // =====================================================================================
  async sendSMS(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.system.sendSMS,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  // =====================================================================================
  // === all controller ===
  // =====================================================================================
  async baseCodeList(params, callBackFunction) {
    const { data } = await Vue.axios.post(
      URLS.all.baseCodeList,
      JSON.stringify(params),
    );
    return callBackFunction(data);
  },
  // =====================================================================================
  // === redis controller ===
  // =====================================================================================
  async redisLastValue(params, parseResponse) {
    const { data } = await Vue.axios.get(
      URLS.redis.lastValue + "/" + params.sensor_mac,
    );
    return parseResponse(data);
  },
  // =====================================================================================
  // === mongo controller ===
  // =====================================================================================
  async mongoTrand(params, parseResponse) {
    const { data } = await Vue.axios.post(
      URLS.mongo.trend,
      JSON.stringify(params),
    );
    return parseResponse(data);
  },
};

export default Apis;
